const LOADING = "loading"
const ERROR = "error"
const WAITING = "waiting"
const CHOICE = "choise"
const DEALING = "dealing"
const BUSY = "busy"

export { LOADING, ERROR, WAITING, CHOICE, BUSY, DEALING } 